module.exports = __webpack_public_path__ + "static/media/11.1.504fd2e4.png";